import { HStack, Button, useColorModeValue } from '@chakra-ui/react';
import type { DashboardViewToggleProps } from '../dashboard.types';

/**
 * Dashboard View Toggle Component
 * Toggles between "Rocks" and "Company Issues" views
 */
export function DashboardViewToggle({ value, onChange }: DashboardViewToggleProps) {
  const activeBg = useColorModeValue('white', 'gray.700');
  const inactiveColor = useColorModeValue('gray.600', 'gray.400');
  const activeColor = useColorModeValue('gray.900', 'white');
  const containerBg = useColorModeValue('gray.100', 'gray.800');
  const hoverBg = useColorModeValue('gray.200', 'gray.700');

  return (
    <HStack spacing={0} bg={containerBg} rounded="lg" p={1}>
      <Button
        size="sm"
        variant={value === 'rocks' ? 'solid' : 'ghost'}
        colorScheme={value === 'rocks' ? 'blue' : undefined}
        bg={value === 'rocks' ? activeBg : 'transparent'}
        color={value === 'rocks' ? activeColor : inactiveColor}
        onClick={() => onChange('rocks')}
        fontWeight="medium"
        _hover={{
          bg: value === 'rocks' ? activeBg : hoverBg,
        }}
      >
        Rocks
      </Button>
      <Button
        size="sm"
        variant={value === 'company-issues' ? 'solid' : 'ghost'}
        colorScheme={value === 'company-issues' ? 'blue' : undefined}
        bg={value === 'company-issues' ? activeBg : 'transparent'}
        color={value === 'company-issues' ? activeColor : inactiveColor}
        onClick={() => onChange('company-issues')}
        fontWeight="medium"
        _hover={{
          bg: value === 'company-issues' ? activeBg : hoverBg,
        }}
      >
        Company Issues
      </Button>
    </HStack>
  );
}

